import React from "react";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import moment from "moment";
import userperfil from "../images/userperfil.png";

const UserHeadDetail = (props) => {
  return (
    <Row>
      <Col sm="12" md="3">
        {/* img src={`${ props.data.foto && data.foto !== '' ?  props.data.foto : userperfil}`} className="shadow image-avatar-dashboard-user" alt="pic" /> */}
        <img
          src={
            props.data.foto
              ? `${process.env.REACT_APP_URL}/media/${props.data.foto}`
              : userperfil
          }
          style={{ width: "100%" }}
          className="rounded shadow"
          alt="User perfil"
        />
      </Col>
      <Col sm="12" md="4" className="py-3">
        <h6 className="ml-3">
          <small className="text-uppercase font-weight-bold">
            {props.data.puesto && props.data.Puesto_List
              ? props.data.Puesto_List[0].descripcion
              : "Puesto no ingresado"}
          </small>
        </h6>
        <h3 className="font-weight-bold text-uppercase ">
          {props.data.nombre}
        </h3>
        <hr />
        <h6 className="text-muted">
          <small>
            Dirigido por:{" "}
            {props.data.jefe && props.data.jefe.length > 0
              ? props.data.jefe[0].nombre
              : "Aún no asignado"}
          </small>
        </h6>
        <h6 className="text-muted">
          <small>
            ultima actualización hace{" "}
            {moment().diff(moment(props.data.updated_at), "days")} días
          </small>
        </h6>
        {/* <Link to={props.data.unidad_organizativa && props.data.unidad_organizativa.length > 0 ? parseInt(props.type) === 1 ? `/estructura-unidad/${props.data.Unidad_Organizativa_List[0].id}/${props.data.Unidad_Organizativa_List[0].nombre}` : `/funcional-estructura-unidad/${props.data.Unidad_Organizativa_List[0].id}/${props.data.Unidad_Organizativa_List[0].nombre}` : ''}><small><i className="material-icons">account_tree</i> Estructura Org.</small></Link> */}
        <Link
          to={
            props.data.unidad_organizativa &&
            props.data.unidad_organizativa.length > 0
              ? `/estructura-unidad/${
                  props.data.Unidad_Organizativa_List[0].id
                }/${props.data.Unidad_Organizativa_List[0].nombre.replace(
                  "/",
                  "-"
                )}/${parseInt(props.type)}`
              : ""
          }
        >
          <small>
            <i className="material-icons">account_tree</i> Estructura Org.
          </small>
        </Link>
      </Col>
    </Row>
  );
};

export default UserHeadDetail;
